import type { Ref } from 'vue';

import type { MenuItem, PrimeVueMenuItem } from '../types';
import MenuConstructor from './MenuConstructor';

export default class AppMenu {
  private readonly adminMenu: MenuConstructor;

  private readonly affiliateMenu: MenuConstructor = new MenuConstructor();

  constructor() {
    this.adminMenu = new MenuConstructor();
    this.affiliateMenu = new MenuConstructor();
  }

  addChildAdminMenuItem(parentItem: MenuItem['id'], item: MenuItem): void {
    this.adminMenu.addChildItem(parentItem, item);
  }

  addAdminMenuItem(item: MenuItem): void {
    this.adminMenu.addItem(item);
  }

  addChildAffiliateMenuItem(parentItem: MenuItem['id'], item: MenuItem): void {
    this.affiliateMenu.addChildItem(parentItem, item);
  }

  addAffiliateMenuItem(item: MenuItem): void {
    this.affiliateMenu.addItem(item);
  }

  getAdminMenu(): Ref<PrimeVueMenuItem[]> {
    return this.adminMenu.getItems();
  }

  getAffiliateMenu(): Ref<PrimeVueMenuItem[]> {
    return this.affiliateMenu.getItems();
  }
}
